<template>
	<transition name="modal" type="animation" mode="out-in">
		<div class="ht-modal" :class="`size-${size}`" @click="close">
			<div class="modal-wrapper" @click.stop>
				<div class="modal-container">
					<div class="modal-header">
						<slot name="header">
							default header
						</slot>
					</div>

					<div class="modal-body">
						<slot name="body">
							default body
						</slot>
					</div>

					<!-- <div class="modal-footer">
						<slot name="footer">
							default footer
							<button class="modal-default-button" @click="close">OK</button>
						</slot>
					</div> -->
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'HtModal',
	props: ['size'],
	methods: {
		close() {
			this.$emit('close');
		},
		onEscapeKeyUp(event) {
			if (event.which === 27) {
				this.close();
				// this.$emit('close');
				event.preventDefault();
			}
		}
	},
	beforeMount() {
		window.addEventListener('keyup', this.onEscapeKeyUp);
	},
	beforeDestroy() {
		window.removeEventListener('keyup', this.onEscapeKeyUp);
	},
}
</script>

<style scoped>
.ht-modal {
	position: fixed;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .5);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all .1s ease;
}

.modal-wrapper {
	max-height: 100%;
	overflow: auto;
	background: white;
}

.modal-container {
	width: 32.0rem;
	margin: 0 auto;
	padding: 1.6rem;
	background-color: var(--card-background-color);
	border-radius: .4rem;
	box-shadow: 0 .2rem .8rem rgba(0, 0, 0, .33);
	max-width: 100%;
}

.size-l .modal-container {
	width: 64.0rem;
}

.size-xl .modal-container {
	width: 960.0rem;
}

.modal-header h3 {
	margin-top: 0;
}

.modal-body {
	margin-top: 1.6rem;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter,
.modal-leave-active {
	opacity: 0;
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>